import { render, staticRenderFns } from "./NotificationDetailsForVendor.vue?vue&type=template&id=3fdf5065"
import script from "./NotificationDetailsForVendor.vue?vue&type=script&lang=js"
export * from "./NotificationDetailsForVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports